class Task {
    constructor(project, taskData, startOffset) {
        this.project = project;

        this.parseTaskData(taskData);
        this.setupDefaultValues(startOffset);

    }

    getData() {
        return {
            startHour: this.startHour,
            resourceGroupID: this.resourceGroupID,
            isFinished: this.isFinished(),
            totalWorkHours: this.totalWorkHours,
            currWorkedHours: this.currWorkedHours,
        };
    }

    getUniqueID() {
        return this.project.projectIndex + "_" + this.taskID;
    }

    parseTaskData(taskData) {
        //Related to namings
        this.taskName = taskData["Task_Name"];
        this.resourceGroupID = taskData["Res_Group_UID"];
        this.taskID = String(taskData["Task_UID"]);

        //How much work is needed;
        this.totalWorkHours = parseInt(taskData["Scheduled_Work_Hours"]);

        //How its connected
        this.predecessorsIDS = String(taskData["Unique_ID_Predecessors"]).split(';');

        //For visuals
        this.row = parseInt(taskData["Row"]);
    }

    setupDefaultValues(startOffset) {
        this.currWorkedHours = 0;
        this.parentTasks = [];
        this.childTasks = [];

        this.startHour = startOffset;

        this.isReadyToStartHour = -1;
        this.startedWorkHour = -1;

        //For the gantt
        this.originalStartHour = null;

        //Ease of access
        this.currentResource = null;

        //For optimising
        this.shiftedThisIteration = false;
    }

    // When a resource is working on this task
    registerResource(resource) {
        this.currentResource = resource;
    }

    // When no resource is working on this task
    unregisterResource() {
        this.currentResource = null;
    }

    registerParentTask(task) {
        this.parentTasks.push(task);
    }

    registerChildTask(task) {
        this.childTasks.push(task);
    }

    isInitialTask() {
        return this.predecessorsIDS[0] == '';
    }

    isFinished() {
        return this.currWorkedHours >= this.totalWorkHours;
    }

    isFinalTask() {
        return this.childTasks.length == 0;
    }

    isReadyToStart() {
        var readyToStart = true;

        this.parentTasks.forEach(currParent => {
            readyToStart &= currParent.isFinished();
        });
        readyToStart &= this.startHour <= this.project.simulator.hoursPassed;

        return readyToStart && !this.isFinished();
    }

    performWork(workAmount) {
        if(this.startedWorkHour < 0){
            this.startedWorkHour = this.project.simulator.hoursPassed - 1;
        }

        this.currWorkedHours += workAmount;

        if(this.isFinished()){
            var data = {taskName: this.taskName, projectIndex: this.project.projectIndex, projectTemplate: this.project.name, estimationTime: this.totalWorkHours, startTime: this.startedWorkHour, endTime: this.project.simulator.hoursPassed, waitingTime: this.startedWorkHour - this.isReadyToStartHour};
            data.processingTime = data.endTime - data.startTime;
            data.flowTime = data.processingTime + data.waitingTime;
            data.readyToStartTime = this.isReadyToStartHour;
            this.project.simulator.finishedTasks.push(data);
        }
    }

    getRemainingWorkHours(){
        return this.totalWorkHours - this.currWorkedHours;
    }

    //Get all child tasks in the chain
    getAllChildTasks() {
        var childTasks = {};
        
        this.childTasks.forEach(childTask => {
            childTasks[childTask.taskID] = childTask;
            var childChildTasks = childTask.getAllChildTasks();
            Object.assign(childTasks, childChildTasks);
        });

        return childTasks;
    }

    //Shift the task to the left as far as possible
    shiftToLeft(hoursPassed) {
        
        if(this.isReadyToStartHour < 0 && this.isReadyToStart()){
            this.isReadyToStartHour = this.project.simulator.hoursPassed - 1;
        }


        //Already shifted
        if (this.shiftedThisIteration) {
            return;
        }

        // First shift the parents
        this.parentTasks.forEach(parentTask => {
            parentTask.shiftToLeft(hoursPassed);
        });

        //Check if all the parents are finished
        var allFinished = true;
        this.parentTasks.forEach(parentTask => {
            allFinished &= parentTask.isFinished();
        })

        //If the parents are all finished, we are also finished
        if (allFinished) {
            this.shiftedThisIteration = true;
            //Set the originalStartHour
            if (this.originalStartHour == null) {
                this.originalStartHour = this.startHour;
            }
            return;
        }

        // Get the end hours for all the parents
        var parentEndHours = []
        this.parentTasks.forEach(parentTask => {
            var projectedParentEndHour = parentTask.startHour + parentTask.totalWorkHours;
            parentEndHours.push(projectedParentEndHour);
        });

        //Get the maximum shift
        var plannedStart = Math.max(...parentEndHours);
        if (parentEndHours.length == 0)
            plannedStart = this.startHour;

        if (plannedStart < hoursPassed) {
            plannedStart = Math.ceil(plannedStart);
        }
        this.startHour = plannedStart;

        if (this.originalStartHour == null) {
            this.originalStartHour = this.startHour;
        }
        this.shiftedThisIteration = true;
    }
}

module.exports = { Task }
